import { render, staticRenderFns } from "./ClientDeploy.vue?vue&type=template&id=4c4cd936&scoped=true&"
import script from "./ClientDeploy.vue?vue&type=script&lang=js&"
export * from "./ClientDeploy.vue?vue&type=script&lang=js&"
import style0 from "./ClientDeploy.vue?vue&type=style&index=0&id=4c4cd936&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4cd936",
  null
  
)

export default component.exports